<template>
  <div>
    <v-layout row wrap fill-height align-content-space-between class="mb-3 parts-results-page">
      <v-flex grow>
        <v-card>
          <Toolbar/>
        
          <v-divider></v-divider>

          <!---TABLE-->
          <Groups ref="table-parts" :headers="this.headers"
            :groups="selected_parts"
            :filter_text="this.search" :grouped_by="this.grouped_by" :showing_selected_parts="this.showSelected"
            :disable_select_action="this.showSelected" />


        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Table from './Table.partList.js';

export default {
  extends: Table,
  components: {
    Groups: () => import("@/components/Table/PartList/Desktop/Groups.desktop"),
    Toolbar: () => import("./Toolbar.partList.vue")
  }
}
</script>

<style lang="stylus" scoped>
  .paginationCard {
    margin-top: 56px;
  }
  
  .name{
    width: 100px;
  }
  .theme--light.v-table tbody tr.extended:not(:last-child)
    border-bottom none

    td
      border-bottom 1px solid rgba(0,0,0,.12);

  .border-right
    border-right 1px solid rgba(0,0,0,.12);

  // .extension-row
  //   &:hover
  //     background-color var(--v-secondary-lighten2)

    p
     margin-bottom .5em

    .description-cell
      ul
        padding 0
      li
        display flex
        align-items flex-start

        &.additional-description-comment
          p
            opacity .65
          i
            display none
            opacity .25
        &.specific-condition-comment
          color: var(--v-warning-darken3)
          opacity 1
        &:last-of-type
          margin-bottom 1em
      i
        margin-top .08em
        margin-right .5em
        font-size 14px

  tr:hover + .extension-row
    background-color var(--v-secondary-lighten2)
  
  tr.extended
    position relative

  tr.extended[data-hover-active="true"]
    background-color var(--v-base-lighten2)

  .extension-rows
    &:hover
      background-color var(--v-base-lighten2)

    p
     margin-bottom .7em

    .description-cell
      ul
        padding 0
      li
        display flex
        align-items flex-start

        &.additional-description-comment
          p
            opacity .65
          i
            display none
        &:last-of-type
          margin-bottom 1.1em

  /* Phone styles */
  @media( max-width: 750px)
    tr[active]
      background-color transparent

  @media screen and (min-width: 1904px)
    .description-cell
      padding-right: 100px !important


</style>